/* Servicio Total · Puntos para los carruseles horizontales (móvil y tablet).
   El carrusel en sí es sólo CSS (scroll-snap); esto agrega los puntos de posición. */
(function () {
  var SEL = '.st-hero .st-quick,.stv-grid,.st-cards__grid,.st-plans__grid,.st-sym__grid,.st-rev,.st-gallery,.st-cgrid,.st-pgrid:not(.st-pgrid--coll),.st-team,.stv-cols';
  function setup(el) {
    if (el.__stDots) return el.__stDots.update();
    var dots = document.createElement('div');
    dots.className = 'st-dots';
    dots.setAttribute('aria-hidden', 'true');
    el.parentNode.insertBefore(dots, el.nextSibling);
    var items = [];
    function build() {
      items = [].slice.call(el.children).filter(function (c) { return c.offsetParent !== null; });
      dots.innerHTML = '';
      items.forEach(function (it, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.tabIndex = -1;
        b.addEventListener('click', function () { el.scrollTo({ left: it.offsetLeft - el.offsetLeft - parseFloat(getComputedStyle(el).paddingLeft || 0), behavior: 'smooth' }); });
        dots.appendChild(b);
      });
    }
    function active() {
      var x = el.scrollLeft, best = 0, bestD = Infinity, base = items[0] ? items[0].offsetLeft : 0;
      items.forEach(function (it, i) { var d = Math.abs(it.offsetLeft - base - x); if (d < bestD) { bestD = d; best = i; } });
      if (el.scrollLeft + el.clientWidth >= el.scrollWidth - 4) best = items.length - 1;
      [].forEach.call(dots.children, function (b, i) { b.setAttribute('aria-current', i === best ? 'true' : 'false'); });
    }
    function update() {
      var scrolls = el.scrollWidth > el.clientWidth + 4;
      dots.hidden = !scrolls;
      if (scrolls) { if (!dots.children.length) build(); active(); }
    }
    var t;
    el.addEventListener('scroll', function () { cancelAnimationFrame(t); t = requestAnimationFrame(active); }, { passive: true });
    el.__stDots = { update: update };
    update();
  }
  function run() { document.querySelectorAll(SEL).forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  var rt;
  window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(run, 150); });
  document.addEventListener('shopify:section:load', run);
})();
